import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";
import { motion, useInView } from "framer-motion";

const translations = {
  tr: {
    title: "Ben Front-End Geliştirici",
    name: "İdris Aktaş",
    description: "React, React Native, TypeScript ve MERN Stack kullanarak fikirleri etkileyici web/mobil deneyimlerine dönüştürüyorum. Birlikte harika projeler inşa edelim!",
  },
  en: {
    title: "I'm Front-End Developer",
    name: "İdris Aktaş",
    description: "Turning ideas into impactful web/mobile experiences with React, React Native, TypeScript and the MERN Stack. Let's build something amazing together!",
  },
};

const TextContent = ({ currentLang = "tr" }) => {
  const textRef = useRef(null);
  const isTextInView = useInView(textRef, { once: true });

  // Gelen prop'u küçük harfe çevirip güvenli hale getiriyoruz.
  const normalizedLang = String(currentLang).toLowerCase();
  const t = translations[normalizedLang] || translations.tr;

  return (
    <motion.div
      ref={textRef}
      initial={{ opacity: 0.3, x: 90 }}
      animate={isTextInView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 1 }}
    >
      <Box border={"2px solid #305041"} bgcolor={"#ffffff7d"} p={3} sx={{ maxWidth: "600px", textAlign: { xs: "center", md: "left" } }}>
        <Typography variant="H48px" mb={2} color="textPrimary">
          {t.title}
          <br />
          {t.name}
        </Typography>

        <Typography color="textSecondary" mt={2}>
          {t.description}
        </Typography>
      </Box>
    </motion.div>
  );
};

const HeroSection = ({ currentLang = "tr" }) => {
  // HeroSection seviyesinde de gelen prop'u normalize ediyoruz
  const normalizedLang = String(currentLang).toLowerCase();

  return (
    <Box sx={{ 
      position: 'relative', 
      display: 'flex', 
      flexDirection: { xs: "column", md: "row" }, 
      alignItems: "center",
      justifyContent: "space-evenly",
      gap: { xs: 5, md: 0 }, 
      padding: { xs: "200px 35px 120px 35px", md: "250px 50px 200px 50px" },
    }}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "url('/about.webp')",
        backgroundSize: { xs: "250%", sm: "200%", md: "110%", lg: "78%" },
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        opacity: 0.7,
        filter: "blur(5px)",
        zIndex: -1,
      }} />
      
      {/* Normalize edilmiş dili alt bileşene güvenle aktarıyoruz */}
      <TextContent currentLang={normalizedLang} />
    </Box>
  );
};

export default HeroSection;